<template>
    <div>
        <span v-if="notes" :title="notes">
            <span v-html="filter().shortenStripDescriptionChars(notes)"></span>&nbsp;
            <a v-if="notes.length>200" href="javascript:void(0)" :id="'exPopover2_'+rowIndex" class="text-primary text-underline"
                @click="fn().showPopover('exPopover2_'+rowIndex)">More</a>
            <b-popover :target="'exPopover2_'+rowIndex">
                <template slot="title">
                    <div style="padding-top:10px;padding-bottom:10px;">
                        <strong style="font-size:16px;">Description</strong>
                        <a class="text-danger pull-right" href="javascript:void(0);" @click="fn().hidePopover()">
                         <i class="fa fa-times"></i>
                        </a>
                    </div> 
                </template>
                <div v-html="notes"></div>
            </b-popover>
        </span>
        <span v-else>NA</span>
    </div>
</template>
<style scoped></style>
<script>
import Vue from "vue";
import CommonFactory from '@/mixins/common.factory';
export default Vue.extend({
    mixins:[CommonFactory],
    data() {
        return {
            rowIndex:-1,
            notes:null
        }
    },
    created(){
        let _self=this;
        _self.rowIndex=_self.params.rowIndex;
        _self.notes=_self.params.value;
    },
});
</script>
